import { useState, useEffect } from "react";
// import "./styles/PanelConfig.css";
import Search from "../generales/Search";
import Modal from "react-modal";
// import Action from "../Action";
import Action from "../Action";
import LoadSimple from "../LoadSimple";
// import TableTech from "./Tech/TableTech";
// import InfoPortafolio from "./Criticidad/InfoPortafolio";
import Paginador from "../generales/Paginador";
// import ModalCreateTech from "./Tech/ModalCreateTech";
// import ImportInfo from "./Proxies/ImportInfo";
import { capitalizeFirstLetter } from "../../utils/utils";
import { lang } from "../generales/traduction";
import Devices from "./Devices";
import TableGrupos from "./TableGrupos";
const CreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "40%",
    padding: "20px",
  },
};
const ImportModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "70%",
    padding: "20px",
  },
};
const PanelTableGroups = ({ server,languaje,mode,handleShowPopup,
  dataView,
  techSelected,
  showHistoric,
  dataAnalisis,
  listSelected,
  municipios
 }) => {
  const viewSelected=(dataView.loading || listSelected==0 )?{group_ids:municipios}:dataView.data.data.filter(item => item.id == listSelected)[0]
  const filtered = (dataAnalisis.loading || dataView.loading || viewSelected.length==0 )?[]:dataAnalisis.data.filter(item => viewSelected.group_ids.includes(item.groupid));
  /*************codgo para fltrado mas rapdo */
  // const groupidSet = new Set(B);
  // const filtered = A.filter(item => groupidSet.has(item.groupid));

  const [limitList, setLimitList] = useState(10);
  const [pageActual, setPageActual] = useState(1);
  const [totalRecord,setTotalRecord]=useState(0)
  const [dataDevices,setDataDevices]=useState({data:{},loading:true,error:{}})
  const [CreateCisModalOpen, setCreateCisModalOpen] = useState(false);
  const [ImportModalOpen, setImportModalOpen] = useState(false);
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: true,
    error: null,
  });
  // console.log("total records "+(parseInt(pageActual ) * parseInt(limitList)))
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  var dataList = searchTerm === "" ? filtered : searchResults;
  // var dataList = dataAnalisis.data;
  const [devices, setDevices] = useState({
    data: [],
    loading: true,
    error: null,
  });
  // const startLimit=(searchTerm==='')?((limitList*pageActual)-limitList):0;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  // const [pages,setPages]=useState(1)
  // console.log(dataUsers);
  // console.log(dataList);
  const [searchResult, setSearchResult] = useState(null);
  const [contRowsSelected,setContRowSelected]=useState(0)
  const [registerIsValid, setRegisterIsValid] = useState(false);
  const [editActive, setEditActive] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataCis, setDataCis] = useState([]);
  const [loadingCis, setLoadingCis] = useState(false);
  const [errorCis, setErrorCis] = useState(null);
  const [cisSelected, setCisSelected] = useState([]);
  const [groupSelected,setgroupSelected]=useState([])
  const [poolRows,setPoolRows]=useState([])
  const [allSelected, setAllSelected] = useState(false);
  const [exportLoading,setExportLoading]=useState(false)
  // console.log(loading);
  const obtenerFechaActualLocal = () => {
    const ahora = new Date();
    const anio = ahora.getFullYear();
    const mes = String(ahora.getMonth() + 1).padStart(2, "0"); // El mes se cuenta desde 0
    const dia = String(ahora.getDate()).padStart(2, "0");
    const horas = String(ahora.getHours()).padStart(2, "0");
    const minutos = String(ahora.getMinutes()).padStart(2, "0");

    return `${anio}-${mes}-${dia}_${horas}-${minutos}`;
  };
  useEffect(() => {
    // setPageActual(1);
  }, [dataList]);
  const handleSearch = (query) => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setSearchResult(`Resultados para: ${query}`);
  };
  const crear = () => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setCreateCisModalOpen(true);
  };
  function closCreateCisModal() {
    setSearchTerm("")
    setEditActive(false);
    setCreateCisModalOpen(false);
  }
  const import_info = () => {

    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setImportModalOpen(true);
   
  };
  function closeImportModal() {
    // console.log('cierra modal import')
    setSearchTerm("")
    setImportModalOpen(false);
    setAllSelected(false)
        setPoolRows([])
  }
  const handleChangEdit = (element) => {
    setgroupSelected(element)
    setEditActive(true);
    setCreateCisModalOpen(true)
  };
  useEffect(() => {
    // search_devices();
  }, []);





  const Exportar=(file_type)=>{
    
    let method='POST'
const body={
  "file_type": file_type,
  "dispIds": poolRows
}
    setExportLoading(true)
      const fetchDataPost = async () => {
        
     try {
       // console.log(method,server.url+'/api/v1/cassia/tech_devices/export')

       // console.log(localStorage.getItem('access_token'))
       const response = await fetch(server.url+'/api/v1/cassia/tech_devices/export', {
         method: method,  
         headers: {
            "Accept": "application/json",
           // 'Content-Type': 'application/json',
           'Content-Type': 'application/json',
             Authorization: `Bearer ${localStorage.getItem('access_token')}`,
           },
         body: JSON.stringify(body),
       });
       if (response.ok) {
        // Dependiendo del tipo de archivo, gestionamos el blob y descargamos
     const blob = await response.blob();
     const url = window.URL.createObjectURL(blob);
     const link = document.createElement('a');
     link.href = url;

     // Dependiendo del tipo de archivo, nombramos el archivo a descargar
     if (file_type === 'json') {
       link.download = 'Tech.json';
     } else if (file_type === 'csv') {
       link.download = 'Tech.csv';
     } else if (file_type === 'excel') {
       link.download = 'Tech.xlsx'; // Archivo de Excel
     }

     document.body.appendChild(link);
     link.click();
     document.body.removeChild(link);
     setAllSelected(false)
     setPoolRows([])
     setExportLoading(false);
     handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['descargaFileCompleta'])),'', true)

       } else {
         setExportLoading(false);
         throw new Error('Error en la solicitud');
       }
     } catch (error) {
           
        }
      };
  
      fetchDataPost();
      
}

  const handleSelectChange = (e) => {
    setLimitList(e.target.value);setPageActual(1);
  };

  const [importLoading, setImportLoading] = useState(false);
  return (
   <>
   <div className='head-cis'>
    <div className='title-cis'>
               { (dataAnalisis.loading)?'':
                  <Search
                    searchResults={searchResults}
                    setSearchResults={setSearchResults}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    onSearch={handleSearch}
                    dataObject={filtered}
                    setDataObject={setDataDevices}
                    searchResult={searchResult}
                    setSearchResult={setSearchResult}
                    languaje={languaje}
                  />}
          <div className={"cont-result-registers"+mode}>
         
                  <p style={{  textAlign: "center" }}>
                    &nbsp;
                    {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                      // ((searchTerm=="")?totalRecord:dataList.length) +
                      ((dataAnalisis.loading)?'...':filtered.length)+
                      ") " 
                      }
                  </p> 
          </div>
          {/* <div className="cont-buttons-panel">
                  
                    <Action
                    disabled={false}
                    origen="Azul"
                    titulo={"+ "+capitalizeFirstLetter(lang[languaje]['nuevoRegistro'])}
                    action={crear}
                  />
                  
                  
                </div>
                <div className="cont-buttons-panel" style={{right:'15%'}}>
                  
                 
                
                
                <Action
                    disabled={false}
                    origen="Cielo"
                    titulo={" "+capitalizeFirstLetter(lang[languaje]['importar'])}
                    action={import_info}
                  />
 
              </div> */}
                </div>
                
            </div>
            <div className='cont-cis'>
            <>
      <div className="main-panel-cis">
      <div className="compact-content-portafolio">
      <div className={"content-portafolio-head"+mode}>
        <div className="titleDashTech">{techSelected}</div>
        {
        // (contRowsSelected!=0)?
          <>
          {(exportLoading)?<div className="cont-excels-buttons-portafolio cont-result-registers"  style={{position:'absolute'}}>{capitalizeFirstLetter(lang[languaje]['descargando'])}. . .</div>:
          <>
          {/* {(contRowsSelected==0)?<div className="cont-excels-buttons-portafolio" style={{position:'absolute',background:'#62626233',zIndex:'2'}}></div>:''} */}
          <div className="cont-excels-buttons-portafolio" style={{position:'absolute'}}>
          
                    
                    
                 </div>
           </>
          }
          </>
          // :''
              }
              </div>
        <div className="content-portafolio">
          <div className="cont-portafolio-table">
            <div className="content-card-portafolio" id="content">
              
            <TableGrupos
                      pageActual={pageActual}
                        limitList={limitList} startLimit={startLimit} 
                      dataList={dataList}
                      cisSelected={cisSelected}
                      setCisSelected={setCisSelected}
                      registerIsValid={registerIsValid}
                      searchResults={searchResults}
                      setSearchResults={setSearchResults}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                      dataUsers={dataUsers}
                      setDataUsers={setDataUsers}
                      server={server}
                      setRegisterIsValid={setRegisterIsValid}
                      setData={setData}
                      setLoading={setLoading}
                      setError={setError}
                      handleChangEdit={handleChangEdit}
                      devices={devices}
                      languaje={languaje}
                      mode={mode}
                      setContRowSelected={setContRowSelected}
                      poolRows={poolRows}
                      setPoolRows={setPoolRows}
                      allSelected={allSelected}
                      setAllSelected={setAllSelected}
                      handleShowPopup={handleShowPopup}
                      dataAnalisis={dataAnalisis}
                    ></TableGrupos>
                            
            </div>
          </div>

          </div>
          <div className={"content-portafolio-footer"+mode}>
          <div className="cont-display-paginador" style={{position: 'absolute',left: '0%',justifyContent: 'start'}}>
            
            <div className={"cont-half-display-paginador"+mode}>
            <p style={{  textAlign: "center" }}>
                            &nbsp;
                            {(contRowsSelected!=0)?"("+contRowsSelected+")  "+capitalizeFirstLetter(lang[languaje]['registosSeleccionados']):''}
                      </p> 
                  
            </div>
          </div>  
          <div className="cont-display-paginador">
                    <Paginador  pages={pages}
                                pageActual={pageActual}
                                setPageActual={setPageActual}
                                mode={mode}></Paginador>
          </div>
          <div className="cont-display-paginador">
            <div className={"cont-half-display-paginador"+mode}>
                      
            <div>
      <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
      <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
        <option value={6}>6</option>
        <option value={10} >10</option>
        <option value={20}>20</option>
        <option value={35}>35</option>
        <option value={50}>50</option>
      </select>

      
    </div>
            </div>
            <div className={"cont-half-display-paginador"+mode}>
            <p style={{  textAlign: "center" }}>
                            &nbsp;
                            {"(" +
                        (startLimit + 1) +
                        " - " +(parseInt(pageActual ) * parseInt(limitList))
                        // (dataList.length >  (parseInt(pageActual ) * parseInt(limitList))
                        //   ?(parseInt(pageActual ) * parseInt(limitList))
                        //   : dataList.length)
                           +
                        ")  "+lang[languaje]['de']+" " +
                        // ((searchTerm=="")?totalRecord:dataList.length) +
                        ((dataAnalisis.loading)?'...':filtered.length)+
                        " "+lang[languaje]['resultados']}
                      </p>
                  
            </div>
          </div>  
                    
        </div>
        </div>
      </div>
     

    {/* <Modal
        isOpen={ImportModalOpen}
        // isOpen={false}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closeImportModal}
        style={ImportModalStyles}
        contentLabel="Example Modal2"
        shouldCloseOnOverlayClick={false}
      >
      <ImportInfo
      server={server}
      importLoading={importLoading}
      setImportLoading={setImportLoading}
      closeImportModal={closeImportModal}
      languaje={languaje}
      mode={mode}
      handleShowPopup={handleShowPopup}
    ></ImportInfo>
    </Modal> */}
    </>
                
            </div>
   </>
      
  );
};

export default PanelTableGroups;
